import { StyleSheet, Platform } from 'react-native';

export const styles = StyleSheet.create({
  scrollContainer: {
    flexGrow: 1,
    minWidth: '100%',
  },
  container: {
    borderRadius: 8,
    backgroundColor: '#FBFCFE',
    borderWidth: 1,
    borderColor: '#E0E0E0',
    overflow: 'hidden',
    width: '100%',
    maxWidth: '100%',
    marginBottom: 5,
  },
  
  // Main Header
  mainHeader: {
    backgroundColor: '#005CBC',
    flexDirection: 'row',
    alignItems: 'center',
  },
  addZoneSection: {
    flex: 0.1,
    alignItems: 'center',
    justifyContent: 'center',
    ...Platform.select({
      web: {
        cursor: 'pointer',
      },
    }),
  },
  volumeDistributionSection: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  kcphSection: {
    flex: 0.1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerSectionText: {
    color: '#FFFFFF',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Bold',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontSize: 12,
    fontWeight: '700',
    lineHeight: Platform.select({
      web: 20,
      default: 18,
    }),
    textAlign: 'center',
  },
  headerDivider: {
    width: 1,
    backgroundColor: '#FFFFFF',
    alignSelf: 'stretch',
  },

  // Sub Header
  subHeader: {
    backgroundColor: '#F8F9FA',
    flexDirection: 'row',
    alignItems: 'stretch',
  },
  zonesSection: {
    flex: 0.1,
  },
  zonesHeader: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EFF5FC',
  },
  zonesSubColumn: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FBFCFE',
    borderTopColor: '#E0E0E0',
    borderTopWidth: 1,
    borderBottomColor: '#E0E0E0',
    borderBottomWidth: 1,
  },
  daysGroup: {
    flex: 1,
    flexDirection: 'row',
  },
  dayGroup: {
    flex: 1,
  },
  dayHeader: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EFF5FC',
  },
  dayHeaderText: {
    color: '#3A3A3A',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Medium',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontWeight: '600',
    lineHeight: Platform.select({
      web: 18,
      default: 16,
    }),
    textAlign: 'center',
  },
  daySubColumns: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: '#FBFCFE',
    borderTopColor: '#E0E0E0',
    borderTopWidth: 1,
    borderBottomColor: '#E0E0E0',
    borderBottomWidth: 1,
  },
  restoreSubHeader: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FBFCFE',
    borderTopColor: '#E0E0E0',
    borderTopWidth: 1,
    borderBottomColor: '#E0E0E0',
    borderBottomWidth: 1,
  },
  subColumn: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  subColumnDivider: {
    width: 1,
    backgroundColor: '#E0E0E0',
    alignSelf: 'stretch',
  },
  subHeaderText: {
    color: '#666666',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Medium',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontWeight: '500',
    lineHeight: Platform.select({
      web: 16,
      default: 14,
    }),
    textAlign: 'center',
  },
  dayColumnDivider: {
    width: 1,
    backgroundColor: '#E0E0E0',
    alignSelf: 'stretch',
  },
  kcphGroup: {
    flex: 0.1,
  },
  kcphHeader: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EFF5FC',
  },
  kcphSubColumns: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: '#FBFCFE',
    borderTopColor: '#E0E0E0',
    borderTopWidth: 1,
    borderBottomColor: '#E0E0E0',
    borderBottomWidth: 1,
  },

  // Data Rows
  dataRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
    backgroundColor: '#FBFCFE',
  },
  zoneNameSection: {
    flex: 0.1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  zoneNameText: {
    color: '#3A3A3A',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Medium',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontWeight: '600',
    textAlign: 'center',
  },
  dayInputsContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  inputColumnDivider: {
    width: 1,
    backgroundColor: '#E0E0E0',
    alignSelf: 'stretch',
  },
  inputContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 10,
  },
  input: {
    backgroundColor: '#F8F9FA',
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 4,
    textAlign: 'center',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Regular',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontWeight: '400',
    color: '#3A3A3A',
  },
  defaultInput: {
    backgroundColor: '#D0D0D0',
  },
  overrideInput: {
    backgroundColor: '#FFFFFF',
  },
  // Overlay for highlighting default inputs in a specific row
  rowHighlightOverlay: {
    position: 'absolute',
    borderWidth: 0,
    borderRadius: 0,
    backgroundColor: 'rgba(0, 92, 188, 0.05)',
    pointerEvents: 'none',
    zIndex: 10,
  },
  kcphDataGroup: {
    flex: 0.1,
  },
  kcphInputsContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },

  // Restore Row
  restoreRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
    backgroundColor: '#F8F9FA',
    borderTopWidth: 1,
    borderTopColor: '#E0E0E0',
  },
  restoreContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    paddingVertical: 8,
  },
  restoreButton: {
    width: 75,
    height: 28,
    paddingHorizontal: 0,
    paddingVertical: 0,
    marginRight: 10,
  },
  restoreBadge: {
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 6,
    width: 75,
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 4,
    marginRight: 4,
  },
  restoreBadgeGreen: {
    backgroundColor: '#E8F5E8',
    borderWidth: 1,
    borderColor: '#4CAF50', // Green
  },
  restoreBadgeRed: {
    backgroundColor: '#FFEBEE',
    borderWidth: 1,
    borderColor: '#F44336', // Red
  },
  restoreBadgeBlue: {
    backgroundColor: '#E3F2FD',
    borderWidth: 1,
    borderColor: '#2196F3',
  },
  restoreBadgeText: {
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Medium',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontWeight: '600',
    fontSize: 11,
    textAlign: 'center',
  },
  restoreBadgeTextGreen: {
    color: '#2E7D32',
  },
  restoreBadgeTextRed: {
    color: '#C62828',
  },
  restoreBadgeTextBlue: {
    color: '#1565C0',
  },

  // Restore Column (new column-based design)
  restoreColumnGroup: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F8F9FA',
    borderLeftWidth: 1,
    borderLeftColor: '#E0E0E0',
  },
  restoreColumnContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 4,
    gap: 4,
    flexDirection: 'row'
  },
  restoreBadgesContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 2,
    marginTop: 4,
  },
  restoreSingleBadgeContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 4,
  },
  restoreBadgeSmall: {
    borderRadius: 2,
    paddingHorizontal: 3,
    paddingVertical: 1,
    minWidth: 20,
    alignItems: 'center',
  },
  restoreBadgeTextSmall: {
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Medium',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontWeight: '600',
    fontSize: 9,
    textAlign: 'center',
  },

  // KCPH Total (read-only)
  kcphTotalContainer: {
    paddingHorizontal: 8,
    paddingVertical: 6,
    width: 75,
    alignItems: 'center',
    justifyContent: 'center',
  },
  kcphTotalText: {
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Medium',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontWeight: '600',
    fontSize: 11,
    textAlign: 'center',
    color: '#3A3A3A',
  },

  // Save Row
  saveRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
    backgroundColor: '#FBFCFE',
    borderTopWidth: 1,
    borderTopColor: '#E0E0E0',
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  saveRowContent: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  saveButton: {
    minWidth: 100,
    height: 36,
    backgroundColor: '#005CBC', // Ensure blue background for primary save
    // Do not set color here; DLOButton handles text/spinner color
  },

  // Modal styles
  modalContent: {
    // Container for zone items - no extra styling needed as DLOModal handles the modal styling
  },
  zoneItem: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#D7E5F8',
  },
  zoneItemLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  zoneItemText: {
    marginLeft: 12,
    fontSize: 14,
    fontWeight: '500',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Medium',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
  },
  modalButtonContainer: {
    marginTop: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalOkButton: {
    minWidth: 80,
  },
});